export function isUnlimitedSubscription(subscription) {
  return (
    subscription?.active === true &&
    (subscription.tier === 'unlimited' || subscription.tier === 'unlimited_pro')
  );
}

export function accountDisplay({ subscription, spark, sogni }) {
  const unlimited = isUnlimitedSubscription(subscription);
  return {
    unlimited,
    tier: unlimited ? subscription.tier : null,
    // The bolt is drawn by the chip in CSS: baking a glyph into the value
    // meant the icon could not be styled, sized or swapped with the rest.
    sparkText: !unlimited && spark != null ? Math.floor(Number(spark)).toLocaleString() : '',
    // Raw balances for the payment-method menu, where each token's amount sits
    // next to its option. Null when the balance lookup came back empty.
    spark: spark != null ? Math.floor(Number(spark)) : null,
    sogni: sogni != null ? Number(sogni) : null
  };
}
